<page-title [title]="pageHeading"></page-title>

<div class="di-step-wrapper mt-4">
  <app-vehicle-filter-search [listingType]="type" [cssClass]="''" [type]="'search'"
    (searchResponse)="searchResponse($event)" [filterClass]="'col col-lg-3 mb-3'"></app-vehicle-filter-search>
</div>